/**
 * Admin API endpoints (users / personas / master-data). Global — not region or crop
 * scoped, single-version. Centralized here so a future rename or v1→v2 bump is a
 * one-line change (see V2_MIGRATION_PLAN — Plan 2).
 */

const ADMIN_API_URL = import.meta.env.PA_PERSONA_API_URL;

export const ADMIN_ENDPOINTS = {
  users: () => `${ADMIN_API_URL}/v1/users`,
  userByEmail: (email: string) => `${ADMIN_API_URL}/v1/users?email=${email}`,
  usersByRole: (role: string) => `${ADMIN_API_URL}/v1/users?role=${encodeURIComponent(role)}`,
  directReports: (managerUserId: number, role: string) =>
    `${ADMIN_API_URL}/v1/users?manager_user_id=${managerUserId}&role=${encodeURIComponent(role)}`,
  cropsRegionsMasterData: () => `${ADMIN_API_URL}/v1/crops-regions-master-data`,
  userRolesMasterData: () => `${ADMIN_API_URL}/v1/user-roles-master-data`,
  personas: () => `${ADMIN_API_URL}/v1/personas`,
  personaById: (personaId: string) => `${ADMIN_API_URL}/v1/personas?persona_id=${personaId}`
} as const;
